































































import {
  defineComponent,
  PropType,
  ref,
  watch,
  nextTick,
  useContext
} from '@nuxtjs/composition-api';
import useWindowResize from '~/hooks/useResizeWindow';

export type RelatedAccessoryType = {
  id: number;
  image: string;
  name: string;
  rating_number: number;
  price: number;
  brand: string;
  category: string;
  spli_id: number;
  sku: string;
};
export default defineComponent({
  name: 'RelatedAccessories',
  props: {
    relatedAccessories: {
      type: Array as PropType<RelatedAccessoryType[]>,
      default: () => []
    }
  },
  setup(props) {
    const hasChanged = ref(true);
    const relatedAccCarousel = ref();
    const accessoriesFiltered = ref(props.relatedAccessories);
    const brandsFiltered = ref([]);
    const categoriesFiltered = ref([]);
    const categories = ref([]);
    const brands = ref([]);
    const brandsNumber = {};
    const categoriesNumber = {};

    const { i18n } = useContext();
    const translatedBrandFilter = i18n
      .t('related_accessories_filter_brand')
      .toString();
    const translatedCategoryFilter = i18n
      .t('related_accessories_filter_accessories')
      .toString();

    const selectedBrand = ref(translatedBrandFilter);
    const selectedCategory = ref(translatedCategoryFilter);
    brands.value.unshift(translatedBrandFilter);
    categories.value.unshift(translatedCategoryFilter);

    const filterAccessories = () => {
      if (props.relatedAccessories) {
        props.relatedAccessories.forEach((accessory) => {
          if (!brands.value.includes(accessory.brand))
            brands.value.push(accessory.brand);
        });
        props.relatedAccessories.forEach((accessory) => {
          if (!categories.value.includes(accessory.category))
            categories.value.push(accessory.category);
        });

        accessoriesFiltered.value = props.relatedAccessories.filter(
          (item) =>
            (selectedBrand.value === translatedBrandFilter ||
              item.brand === selectedBrand.value) &&
            (selectedCategory.value === translatedCategoryFilter ||
              item.category === selectedCategory.value)
        );

        Object.keys(brandsNumber).forEach((el) => {
          delete brandsNumber[el];
        });
        Object.keys(categoriesNumber).forEach((el) => {
          delete categoriesNumber[el];
        });
        categoriesNumber[translatedCategoryFilter] = 0;
        brandsNumber[translatedBrandFilter] = 0;

        brands.value.forEach((item) => {
          props.relatedAccessories.forEach((element) => {
            if (
              (selectedCategory.value === translatedCategoryFilter ||
                element.category === selectedCategory.value) &&
              element.brand === item
            ) {
              brandsNumber[translatedBrandFilter] += 1;

              if (typeof brandsNumber[element.brand] !== 'number') {
                brandsNumber[element.brand] = 1;
              } else brandsNumber[element.brand] += 1;
            }
          });
        });

        categories.value.forEach((item) => {
          props.relatedAccessories.forEach((element) => {
            if (typeof categoriesNumber[element.category] !== 'number')
              categoriesNumber[element.category] = 0;

            if (
              (selectedBrand.value === translatedBrandFilter ||
                element.brand === selectedBrand.value) &&
              element.category === item
            ) {
              categoriesNumber[translatedCategoryFilter] += 1;
              categoriesNumber[element.category] += 1;
            }
          });
        });
      }
      hasChanged.value = false;

      brandsFiltered.value = brands.value.filter((element) => {
        return brandsNumber[element] > 0;
      });
      categoriesFiltered.value = categories.value.filter((element) => {
        return categoriesNumber[element] > 0;
      });
      nextTick(() => {
        if (accessoriesFiltered.value && accessoriesFiltered.value.length > 0)
          hasChanged.value = true;
      });

      return accessoriesFiltered.value;
    };

    watch(
      () => props.relatedAccessories,
      () => {
        filterAccessories();
      }
    );

    const AccessoriesCarouselSettings = {
      type: 'slider',
      rewind: false,
      perView: 6,
      focusAt: 0,
      gap: 16,
      breakpoints: {
        1223: {
          perView: 3,
          peek: {
            before: 0,
            after: 50
          }
        },
        767: {
          perView: 1,
          focusAt: 0,
          peek: {
            before: 0,
            after: 0
          }
        }
      }
    };

    filterAccessories();
    return {
      AccessoriesCarouselSettings,
      brandsFiltered,
      brands,
      categories,
      categoriesFiltered,
      selectedBrand,
      selectedCategory,
      accessoriesFiltered,
      hasChanged,
      relatedAccCarousel,
      brandsNumber,
      categoriesNumber,
      filterAccessories
    };
  }
});
